import { getConfigValue } from '@zonofi/common';
import { i18nService, SupportedCurrency } from '@zonofi/i18n';
import { LoadingSpinner } from '@zonofi/zono-money-design-system';
import { WEBROUTES, dispatch } from '@zonofi/zono-money-helpers';
import {
  AddressParam,
  CustomerInviteDetailsResponse,
  CustomerInviteResponse,
  OnGuestUserAuthenticated,
  onSuccess,
  updateCheckoutNotes,
  updateCurrentTooltipIndex,
  updateisSimulation,
  updateIsTourActive,
  updateShippingAddress,
  useRecordEngagementMutation,
} from '@zonofi/zono-money-store';
import axios, { AxiosError } from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import './invite-loading-screen.scss';

export const InviteLoadingScreen: React.FC = () => {
  const nav = useNavigate();
  const params = useParams();
  const { inviteId } = params;
  const [searchParams] = useSearchParams();
  const redirectUrl = searchParams.get('redirectUrl');

  const token = searchParams.get('token');
  const orderId = searchParams.get('poFileId') || searchParams.get('orderId');
  const invoiceId = searchParams.get('invoiceId');
  const campaignId = searchParams.get('campaignId');
  const pricelistId = searchParams.get('pricelistId');
  const surveyFormId = searchParams.get('formId');
  const formAnswerId = searchParams.get('formAnswerId');
  const sellerWorkspaceId = searchParams.get('sellerWorkspaceId');
  const target = searchParams.get('target');
  const esLinkId = searchParams.get('esLinkID');
  const firmName = searchParams.get('firmName');
  const pvIds = searchParams.get('pvIds');
  const segmentIds = searchParams.get('segmentIds');
  const skuCode = searchParams.get('skuCode');
  const productId = searchParams.get('productId');
  const categoryId = searchParams.get('categoryId');
  const pvId = searchParams.get('pvId');
  const userId = searchParams.get('userId');
  const isSimulation = searchParams.get('isSimulation');
  const hideTour = searchParams.get('hideTour');
  const waSessionId = searchParams.get('sessionId');
  const subFolder = searchParams.get('subFolder');
  const docNumber = searchParams.getAll('docNumber');
  const isMember = searchParams.get('isMember') === 'true';
  const addressParam = searchParams.get('address');
  const notesParam = searchParams.get('notes');
  const waConfigId = searchParams.get('waConfigId');
  const typebotId = searchParams.get('typebotId');
  const phone = searchParams.get('phone');
  const attemptId = searchParams.get('attemptId');

  const address = JSON.parse(addressParam) as AddressParam;
  const notes = JSON.parse(notesParam);

  console.log('notesParam: ', notesParam);
  console.log('notes: ', notes);

  const [error, setError] = useState({
    show: false,
    code: null,
    details: null,
  });

  const [recordEngagement] = useRecordEngagementMutation();

  const navigate = (path: string) => {
    let extraParams = `token=${token}&inviteId=${inviteId}&sellerWorkspaceId=${sellerWorkspaceId}`;
    if (path?.includes('?')) {
      path = `${path}&${extraParams}`;
    } else {
      path = `${path}?${extraParams}`;
    }
    nav(path);
  };

  useEffect(() => {
    if (notes && notes?.length !== 0) {
      dispatch(updateCheckoutNotes(notes));
    }
  }, [notes]);

  useEffect(() => {
    if (address) {
      const shippingdecodedAddress = {
        fullName: '',
        company: '',
        streetLine1: address?.address || '',
        streetLine2: '',
        city: '',
        province: '',
        postalCode: '',
        countryCode: '',
        phoneNumber: '',
        latitude: address?.latitude || 0,
        longitude: address?.longitude || 0,
      };
      dispatch(updateShippingAddress(shippingdecodedAddress));
    }
  }, [address]);

  useEffect(() => {
    console.log('1st console log');
    if (token) {
      dispatch(OnGuestUserAuthenticated(token));
    }
  }, [token]);

  React.useEffect(() => {
    console.log('targettttttttttttt', target, esLinkId, searchParams);
    if (target === 'es') {
      navigate(
        `${WEBROUTES.ES_SCREEN}?esLinkId=${esLinkId}&sellerWorkspaceId=${sellerWorkspaceId}&firmName=${firmName}&userId=${userId}`
      );
    }
  }, [target]);

  useEffect(() => {
    console.log('2nd consle log');
    if (isSimulation === 'true') {
      dispatch(updateisSimulation(true));
      if (hideTour && hideTour === 'true') {
        dispatch(updateIsTourActive(false));
      } else {
        dispatch(updateIsTourActive(true));
        dispatch(updateCurrentTooltipIndex(0));
      }
    }
    if (redirectUrl) {
      getRedirectUrl();
    } else if (inviteId || target === 'es') {
      console.log('before fetching inviteId', inviteId);
      const baseUrl = getConfigValue('API_ENDPOINT');
      console.log('baseUrl: ', baseUrl);
      const url = `${baseUrl}hub/orgs/api/customer/details`;
      console.log('url: ', url);
      // fetchInviteDetails(inviteId);
      // Define the URL

      // Make a GET request using Axios
      axios
        .get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            inviteId: inviteId,
            sellerWorkspaceId: sellerWorkspaceId,
            customerId: inviteId,
            includeInactive: false,
            includeCFA: false,
          },
        })
        .then((response) => {
          // Log the response data
          // Store the response data in a variable or wherever you need
          // For example, you can assign it to a variable
          const responseData = response?.data as CustomerInviteDetailsResponse;
          const storeData: CustomerInviteResponse = {
            inviteId: responseData?.inviteId,
            seller: {
              name: responseData?.workspace?.spaceName,
              phone: responseData?.workspace?.mobile || '',
              email: responseData?.workspace?.companyEmail,
              workspaceId: sellerWorkspaceId,
              profileImg: responseData?.sellerWorkspaceImage,
            },
            buyer: {
              name: responseData?.companyName,
              phone: responseData?.telephone,
              workspaceId: '',
              inviteType: responseData?.invite?.inviteType,
              waSessionId,
            },
            isMember,
          };
          if (responseData?.waConfig) {
            storeData.waConfig = {
              ...(responseData?.waConfig || {}),
              wabaId: responseData?.waConfig?.wabaId,
              whatsappPhoneNo: responseData?.waConfig?.whatsappPhoneNo,
            };
          }
          if (responseData.workspace) {
            storeData.workspaceConfig = {
              currency: responseData.workspace
                .defaultCurrencyCode as SupportedCurrency,
              timezone: responseData.workspace.timezone,
            };
          }
          dispatch(onSuccess(storeData));
          if (campaignId) {
            recordEngagement({
              campaignId: campaignId,
              customerId: inviteId,
              sellerWorkspaceId: sellerWorkspaceId,
              workspaceId: sellerWorkspaceId,
            });
          }
          if (target === 'reorder') {
            navigate(`${WEBROUTES.REORDER}/${orderId}`);
          } else if (orderId) {
            navigate(`${WEBROUTES.ORDER}/${orderId}`);
          } else if (target === 'kyc') {
            navigate(`${WEBROUTES.GST_SCREEN}`);
          } else if (target === 'campaign' && campaignId) {
            navigate(
              `${WEBROUTES.CAMPAIGN}/${campaignId}${
                pvIds ? `?pvIds=${pvIds}` : ``
              }`
            );
          } else if (target === 'es') {
            navigate(
              `${WEBROUTES.ES_SCREEN}?esLinkId=${esLinkId}&sellerWorkspaceId=${sellerWorkspaceId}&firmName=${firmName}&userId=${userId}`
            );
          } else if (target === 'price-list' && pricelistId) {
            navigate(`${WEBROUTES.PRICELIST}/${pricelistId}`);
          } else if (target === 'survey' && surveyFormId) {
            let params = [];
            if (formAnswerId) {
              params?.push(`formAnswerId=${formAnswerId}`);
            }
            if (waConfigId) {
              params?.push(`waConfigId=${waConfigId}`);
            }
            if (typebotId) {
              params?.push(`typebotId=${typebotId}`);
            }

            navigate(
              `${WEBROUTES.SURVEY_FORM}/${surveyFormId}${
                params?.length !== 0 ? '?' : ''
              }${params?.join('&')}`
            );
          } else if (target === 'product') {
            let params = [];
            if (pvId) {
              params?.push(`pvId=${pvId}`);
            }
            if (campaignId) {
              params?.push(`campaignId=${campaignId}`);
            }
            if (attemptId) {
              params?.push(`attemptId=${attemptId}`);
            }
            navigate(
              `${WEBROUTES.PRODUCT_DETAILS}${productId ? `/${productId}` : ``}${
                params?.length !== 0 ? '?' : ''
              }${params?.join('&')}`
            );
          } else if (target) {
            if (target === 'catalog') {
              let params = [];
              if (categoryId) {
                params?.push(`categoryId=${categoryId}`);
              }
              if (pvIds) {
                params?.push(`pvIds=${pvIds}`);
              }
              if (segmentIds) {
                params?.push(`segmentIds=${segmentIds}`);
              }
              if (skuCode) {
                params?.push(`skuCode=${skuCode}`);
              }
              if (campaignId) {
                params?.push(`campaignId=${campaignId}`);
              }
              if (attemptId) {
                params?.push(`attemptId=${attemptId}`);
              }
              navigate(
                `${WEBROUTES.CATALOGUE}${
                  params?.length !== 0 ? '?' : ''
                }${params?.join('&')}`
              );
            } else if (target === 'cart') {
              navigate(WEBROUTES.CART);
            } else if (target === 'kyc') {
              navigate(`${WEBROUTES.GST_SCREEN}`);
            } else if (target === 'invoice') {
              let params = [];
              if (subFolder) {
                params.push(`subFolder=${subFolder}`);
              }
              if (docNumber) {
                params.push(`docNumber=${docNumber}`);
              }
              navigate(
                `${WEBROUTES.INVOICE}/${invoiceId}${
                  params?.length !== 0 ? '?' : ''
                }${params?.join('&')}`
              );
            } else if (target === 'dialer' && phone) {
              navigate(`${WEBROUTES.DIALER_REDIRECT}?phone=${phone}`);
            } else {
              navigate(WEBROUTES.ERROR_SCREEN);
            }
          } else navigate(WEBROUTES.UNAUTHORIZED_SCREEN);

          // Now you can work with the responseData object
          // For example, you can access its properties like responseData.propertyName
        })
        .catch((error: AxiosError) => {
          // Log any errors that occurred during the Axios request
          console.error('Axios Error:', error);
          if (error?.response?.status === 401) {
            navigate(WEBROUTES.ERROR_SCREEN);
          }
          setError({
            show: true,
            code: error?.response?.status,
            details: error?.message,
          });
        });
      console.log('after fetching inviteId', inviteId);
    }
  }, [inviteId]);

  const getRedirectUrl = () => {
    const temp = new URLSearchParams(window.location.search);

    // Get and remove redirectUrl from parameters
    const redirectUrl = temp.get('redirectUrl');

    if (!redirectUrl) {
      console.error('No redirectUrl found in query parameters');
      return;
    }

    let redirectBaseUrl;
    let allParams;

    try {
      const parsedUrl = new URL(redirectUrl, window.location.origin); // Ensure it works with relative URLs
      redirectBaseUrl = `${parsedUrl.origin}${parsedUrl.pathname}`; // Keep domain + path only
      allParams = new URLSearchParams(parsedUrl.search); // Extract only query parameters from redirectUrl
    } catch (error) {
      console.error('Invalid redirectUrl:', redirectUrl);
      return;
    }
    console.log('allParams:', allParams);
    // Remove redirectUrl from the original URL params
    temp.delete('redirectUrl');

    // Merge remaining parameters from the original URL
    for (const [key, value] of temp.entries()) {
      allParams.append(key, value);
    }

    // Construct the final URL
    const newUrl = `${redirectBaseUrl}${
      allParams.toString() ? `?${allParams.toString()}` : ''
    }`;

    console.log('Redirecting to:', newUrl);
    window.location.assign(newUrl);
  };

  //   const getRedirectUrl = () => {
  //     const allParams = new URLSearchParams(window.location.search);
  //     console.log('allParams: ', allParams);

  //     // Get and remove redirectUrl from parameters
  //     const redirectUrl = allParams.get('redirectUrl');
  //     if (!redirectUrl) {
  //       console.error('No redirectUrl found in query parameters');
  //       return;
  //     }
  //     allParams.delete('redirectUrl');
  //     // Extract the domain from redirectUrl
  //     let redirectBaseUrl;
  //     try {
  //       const parsedUrl = new URL(redirectUrl);
  //       redirectBaseUrl = `${parsedUrl.origin}${parsedUrl.pathname}`; // Keep domain + path only
  //     } catch (error) {
  //       console.error('Invalid redirectUrl:', redirectUrl);
  //       return;
  //     }

  //     // Construct the final URL without redirectUrl but keeping other params
  //     const newUrl = `${redirectBaseUrl}?${allParams.toString()}`;

  //     console.log('Redirecting to:', newUrl);
  //     window.location.assign(newUrl);
  //   };

  // const getRedirectUrl = () => {
  //   const allParams = decodeURIComponent(location.search);
  //   console.log('orderId: ', orderId);
  //   console.log('redirectUrl: ', redirectUrl);

  //   console.log('allParams: ', allParams);
  //   const index = allParams.indexOf(redirectUrl);
  //   console.log('index: ', index);
  //   let url = allParams.slice(index);
  //   console.log('url: ', url);
  //   if (orderId) {
  //     if (!url?.includes('orderId')) {
  //       console.log('no order id in redirect url');
  //       url = url + '&orderId=' + orderId;
  //       console.log('url: ', url);
  //     }
  //   }
  //   console.log('1', url);
  //   window.location.assign(url);
  //   console.log('2');
  // };

  return (
    <div className="invite-loading-screen">
      {error?.show ? (
        <>
          <h2>{error?.code}</h2>
          <span className="font-primary-semibold">{error?.details}</span>
        </>
      ) : (
        <LoadingSpinner />
      )}
    </div>
  );
};
